import React from 'react';
import { CurrencyUtils, TranslationUtils } from '../../utils';
import moment from 'moment';
import { FormattedDate } from 'react-intl';
import { TripAdjustmentResponse } from 'guest-data-types-ts-lib';
import { DiscountDetail } from '../../types/receipt.type';

interface ReceiptLineAddNightProps {
    preview: TripAdjustmentResponse;
    discount_details?: DiscountDetail;
    locale: string;
}

export const ReceiptLineAddNight: React.FC<ReceiptLineAddNightProps> = (props) => {
    const { preview, locale, discount_details } = props;
    const { delta } = preview;
    // @ts-ignore
    const { adjustment_date, original_rent, discount_amount, discount_rent } = discount_details;
    const date = moment(adjustment_date).startOf('day').toString();
    return (
        <>
            <div className="font-weight-bold p-2 d-flex justify-content-between" tabIndex={0} role="button" aria-expanded="false">
                <span className="text-capitalize">
                    {!((discount_amount as number) <= 0)
                        ? `${TranslationUtils.get('payment_form_pricing_discounted_rent')} (1 ${TranslationUtils.get('night_added')})`
                        : `${TranslationUtils.get('rent')} (1 ${TranslationUtils.get('night_added')})`}
                    <i className="pl-2" />
                </span>
                <span className="text-right">
                    {CurrencyUtils.formatCurrency(discount_rent ? discount_rent : delta.rent, delta.currency, locale)}
                </span>
            </div>
            <div className={'mx-3 py-2 price-breakdown-row row'}>
                <div className={'col-7'}>
                    <FormattedDate value={new Date(date)} month="short" day="numeric" weekday="short" />
                </div>
                <div className={'col-5 text-right'}>{CurrencyUtils.formatCurrency(original_rent as number, delta.currency, locale)}</div>
            </div>
            {!((discount_amount as number) <= 0) && (
                <div className={'mx-3 py-2 price-breakdown-row row'}>
                    <div className={'col-7'}>{`${TranslationUtils.get('payment_form_pricing_discount')}`}</div>
                    <div className={'col-5 text-right'}>{`- ${CurrencyUtils.formatCurrency(
                        discount_amount as number,
                        delta.currency,
                        locale
                    )}`}</div>
                </div>
            )}
            <hr className={'detail-separator'} />
        </>
    );
};
